const ORDERED_MARK = /(?:\s+#مرتب)+$/;

export function isQuizOrdered(title?: string | null): boolean {
  return typeof title === 'string' && ORDERED_MARK.test(title.trim());
}

export function stripQuizOrderFlag(title?: string | null): string {
  if (!title || title === 'null') return '';
  return title.replace(ORDERED_MARK, '').trim();
}

export function withQuizOrderFlag(title: string, ordered: boolean): string {
  const clean = stripQuizOrderFlag(title);
  return ordered ? `${clean} #مرتب` : clean;
}
